<template>
  <div class="template" v-if="newAllBetEvent.od[ftPlyType] && newAllBetEvent.od[ftPlyType][htftBetType]">
    <div data-template="template10" class="wrap-template template10">
      <div class="vrow items-center template-title is_fold">
        <div class="play-name col" @click="showLeg()">
          <span class="ellipsis">{{ sportAllBetLang['ALL_BET.SUBHEADER_HTFT'] }}</span>
        </div>
        <div style="width: 37px;" @click="setToTop($event)">
          <span class="set_top" style="display: none;">
            <i aria-hidden="true" role="presentation" class="q-icon icon-set_top c-icon"></i>
          </span>
        </div>
      </div>
      <template v-if="show">
        <div class="handicap m-htft">
          <div class="handicap-item base-item os-1">
            <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
              <div class="bet-inner yb-flex-center fit">
                <div class="handicap-wrap">
                  <div class="bet-item" style="width: 70%">
                    <span class="ellipsis on-text">{{ newAllBetEvent.tacapt }}/{{ newAllBetEvent.tacapt }}</span>
                  </div>
                </div>
                <cstgftht :event="newAllBetEvent" :score="'hh'" :plyType="ftPlyType" :betType="htftBetType"
                  ref="teamhh" />
              </div>
            </div>
          </div>
          <div class="handicap-item base-item os-1">
            <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
              <div class="bet-inner yb-flex-center fit">
                <div class="handicap-wrap">
                  <div class="bet-item" style="width: 70%">
                    <span class="ellipsis on-text">
                      {{ newAllBetEvent.tacapt }}/{{ sportAllBetLang['ALL_BET.LBL_DRAW'] }}
                    </span>
                  </div>
                </div>
                <cstgftht :event="newAllBetEvent" :score="'hd'" :plyType="ftPlyType" :betType="htftBetType"
                  ref="teamhd" />
              </div>
            </div>
          </div>
          <div class="handicap-item base-item os-1 no_border_right">
            <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
              <div class="bet-inner yb-flex-center fit">
                <div class="handicap-wrap">
                  <div class="bet-item" style="width: 70%">
                    <span class="ellipsis on-text">{{ newAllBetEvent.tacapt }}/{{ newAllBetEvent.tbcapt }}</span>
                  </div>
                </div>
                <cstgftht :event="newAllBetEvent" :score="'ha'" :plyType="ftPlyType" :betType="htftBetType"
                  ref="teamha" />
              </div>
            </div>
          </div>
          <div class="handicap-item base-item os-1">
            <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
              <div class="bet-inner yb-flex-center fit">
                <div class="handicap-wrap">
                  <div class="bet-item" style="width: 70%">
                    <span class="ellipsis on-text">{{ sportAllBetLang['ALL_BET.LBL_DRAW'] }}/{{ newAllBetEvent.tacapt
                    }}</span>
                  </div>
                </div>
                <cstgftht :event="newAllBetEvent" :score="'dh'" :plyType="ftPlyType" :betType="htftBetType"
                  ref="teamdh" />
              </div>
            </div>
          </div>
          <div class="handicap-item base-item os-1">
            <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
              <div class="bet-inner yb-flex-center fit">
                <div class="handicap-wrap">
                  <div class="bet-item" style="width: 70%">
                    <span class="ellipsis on-text">
                      {{ sportAllBetLang['ALL_BET.LBL_DRAW'] }}/{{ sportAllBetLang['ALL_BET.LBL_DRAW'] }}
                    </span>
                  </div>
                </div>
                <cstgftht :event="newAllBetEvent" :score="'dd'" :plyType="ftPlyType" :betType="htftBetType"
                  ref="teamdd" />
              </div>
            </div>
          </div>
          <div class="handicap-item base-item os-1 no_border_right">
            <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
              <div class="bet-inner yb-flex-center fit">
                <div class="handicap-wrap">
                  <div class="bet-item" style="width: 70%">
                    <span class="ellipsis on-text">{{ sportAllBetLang['ALL_BET.LBL_DRAW'] }}/{{ newAllBetEvent.tbcapt
                    }}</span>
                  </div>
                </div>
                <cstgftht :event="newAllBetEvent" :score="'da'" :plyType="ftPlyType" :betType="htftBetType"
                  ref="teamda" />
              </div>
            </div>
          </div>
          <div class="handicap-item base-item os-1 no_border_bottom">
            <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
              <div class="bet-inner yb-flex-center fit">
                <div class="handicap-wrap">
                  <div class="bet-item" style="width: 70%">
                    <span class="ellipsis on-text">{{ newAllBetEvent.tbcapt }}/{{ newAllBetEvent.tacapt }}</span>
                  </div>
                </div>
                <cstgftht :event="newAllBetEvent" :score="'ah'" :plyType="ftPlyType" :betType="htftBetType"
                  ref="teamah" />
              </div>
            </div>
          </div>
          <div class="handicap-item base-item os-1 no_border_bottom">
            <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
              <div class="bet-inner yb-flex-center fit">
                <div class="handicap-wrap">
                  <div class="bet-item" style="width: 70%">
                    <span class="ellipsis on-text">
                      {{ newAllBetEvent.tbcapt }}/{{ sportAllBetLang['ALL_BET.LBL_DRAW'] }}
                    </span>
                  </div>
                </div>
                <cstgftht :event="newAllBetEvent" :score="'ad'" :plyType="ftPlyType" :betType="htftBetType"
                  ref="teamad" />
              </div>
            </div>
          </div>
          <div class="handicap-item base-item os-1 no_border_bottom no_border_right">
            <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid1">
              <div class="bet-inner yb-flex-center fit">
                <div class="handicap-wrap">
                  <div class="bet-item" style="width: 70%">
                    <span class="ellipsis on-text">{{ newAllBetEvent.tbcapt }}/{{ newAllBetEvent.tbcapt }}</span>
                  </div>
                </div>
                <cstgftht :event="newAllBetEvent" :score="'aa'" :plyType="ftPlyType" :betType="htftBetType"
                  ref="teamaa" />
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import OddComponents from '../../../components/odd'
import HandicapComponents from '../../../components/handicap'

import allBetMixin from '../../../mixins/allBet'

export default {
  mixins: [allBetMixin],
  props: {
    allBetEvent: null,
    plytyp: null,
    selectMarket: null,
    removeMarket: null,
    rbinfo: null,
    myMarket: {
      type: Boolean,
      default: false
    },
    isSpecial: {
      type: Boolean,
      default: false
    },
    mode:null
  },
  data() {
    return {
      btypes: [allBetMixin.data().htftBetType, allBetMixin.data().rhtftBetType],
      lang: window.lang,
      show: true,
    }
  },
  computed: {
    ...mapGetters([
      'foldopenAllBet',
      'foldopenFirstEvent'
    ]),
    newAllBetEvent() {
      // return _.cloneDeep(this.$store.getters.sortedMatchEventList)
      return this.allBetEvent
    }
  },
  watch: {
    foldopenAllBet() {
      if(this.mode=='ab'){
        this.show = (this.$store.getters.foldopenAllBet) ? true : false;
      }
    },
    foldopenFirstEvent() {
      if(this.mode!='ab'){
        this.show = (this.$store.getters.foldopenFirstEvent) ? true : false;
      }
    }
  },
  methods: {
    getTitleCaption() {
      var a = 'FT'
      var b = ''
      if (this.plytyp == this.firstHtPlyType) {
        a = '1H'
      }

      // if (this.bettype == this.hdpBetType) {
      b = this.sportAllBetLang['ALL_BET.SUBHEADER_' + a + '_HDP']
      // } else if (this.bettype == this.bttsBetType) {
      //   b = this.sportAllBetLang['ALL_BET.SUBHEADER_' + a + '_BTTS']
      // }

      // RB score
      if (this.newAllBetEvent.event_rb == 1) {
        b += ' (' + this.newAllBetEvent.rbinfo.scoa + '-' + this.newAllBetEvent.rbinfo.scob + ')'
      }
      return b
    },
    showLeg() {
      this.show = (!this.show) ? true : false;
    },
    setToTop(e) {
      this.$parent.setToTop(e);
    },
    addToMyMarket(plytyp, htftBetType) {
      if (this.selectMarket)
        this.selectMarket(this.allBetEvent, plytyp, htftBetType, this.isSpecial)
    },
    removeFromMyMarket(plytyp, htftBetType) {
      if (this.removeMarket)
        this.removeMarket(this.allBetEvent, plytyp, htftBetType, this.isSpecial)
    },
  },
  mounted(){
    if(this.mode=='ab'){
      this.show = (this.$store.getters.foldopenAllBet) ? true : false;
    }else{
      this.show = (this.$store.getters.foldopenFirstEvent) ? true : false;
    }
  },
}
</script>



// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/allBet/allBet-htft.vue